import { render, staticRenderFns } from "./ClientInfoComment.vue?vue&type=template&id=da7d15a4&"
import script from "./ClientInfoComment.vue?vue&type=script&lang=js&"
export * from "./ClientInfoComment.vue?vue&type=script&lang=js&"
import style0 from "./ClientInfoComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports